import React, { useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTheme } from "../../../contexts/ThemeContext";

export default function CallHistoryTheme({ children }) {
  const { darkMode } = useTheme();
  const theme = useMemo(() => createTheme({
    palette: { mode: darkMode ? "dark" : "light" },
    components: { MuiButton: { styleOverrides: { root: { textTransform: "none" } } } },
  }), [darkMode]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
